{
  "menu": {
    "home": "HOME",
    "programs": "COUNTRIES",
    "residency": "Residency",
    "citizenship": "Passport & Citizenship",
    "about": "ABOUT US",
    "aboutShort": "ABOUT",
    "partnership": "PARTNERS",
    "education": "EDUCATION",
    "news": "INSIGHTS",
    "contact": "CONTACT"
  },
  "footer": {
    "copyright": "© 2026 Pacific Link International. All rights reserved.",
    "abn": "Australia · ABN 99 673 671 184",
    "quickLinks": "Quick links",
    "immigrationSite": "Immigration Programs",
    "educationSite": "Online Degree Programs",
    "legal": "Legal",
    "legalNotice": "Legal Notice",
    "privacyPolicy": "Privacy Policy",
    "termsOfUse": "Terms of Use"
  }
}
